import DigitalCards from '@/components/DigitalCards/DigitalCards.jsx';
import React from 'react';
import { LoyaltyCard } from '@desquared/wave-components-library';
import LoyaltyCardFront from '../../../public/assets/wave-grocery/LoyaltyCardFront.png';
import { ResponsiveMenuStore } from '@/store/sideSheet';
import { useTranslations } from 'next-intl';
import styles from './Loyalty.module.css';

export default function Loyalty({ user, card, showLoyaltyCardButton }) {
  const t = useTranslations('user_loyalty');

  const openMenu = () => {
    ResponsiveMenuStore.open();
  };

  return (
    <div className={styles.loyaltyContainer}>
      <LoyaltyCard
        LoyaltyWording={t('loyalty')}
        CardCodeWording={t('card_code')}
        CardCode={user.loyaltyCards[0]?.cardId}
        Points={user.totalLoyaltyPoints}
        PointsTotalWording={t('points_total')}
        ClickWording={t('click')}
        onBack={() => {
          openMenu();
        }}
        onCopy={() => {
          navigator.clipboard.writeText(user.loyaltyCards[0]?.cardId);
        }}
        FrontOfCard={card ?? LoyaltyCardFront.src}
        snackBarWording={t('snack_bar')}
      />
      <DigitalCards card={card} user={user} showLoyaltyCardButton={showLoyaltyCardButton} />
    </div>
  );
}
